import React, { useContext, useState } from "react";
import styles from "./Leaderboard.module.css";
import { Context } from "../Store";
import ReactGA from "react-ga4";
import { useHistory, useParams } from "react-router-dom";

const Leaderboard = ({ visibleCount = 6 }) => {
  const [state] = useContext(Context);
  const { parsedPlayers = [] } = state;
  const [showAll, setShowAll] = useState(false);

  const history = useHistory();

  const sortedPlayers = [...parsedPlayers].sort((a, b) => b.points - a.points || b.gold - a.gold || b.silver - a.silver);
  const visiblePlayers = showAll ? sortedPlayers : sortedPlayers.slice(0, visibleCount);

  const { guid } = useParams();

  //  const onPlayerClick = (player) => {
  //     history.push(`/${guid}/player/${player.id}`);
  //   };

  let trackEvent = (category, action, label = "") => {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  };

  return (
    <div className={`${styles.lbSection} section section--padded`}>
      <h2>Leaderboard</h2>
      <div>
        <div className={`${styles.playerRow} ${styles.titleRow} ${styles.flexContainer}`}>
          <span className={styles.name}>Player</span>
          <span className={styles.points}>Points</span>
        </div>
        {visiblePlayers.map((player, index) => (
          // <div className={`${styles.playerRow} ${styles.flexContainer}`} key={index} onClick={() => onPlayerClick(player)} >
          <div className={`${styles.playerRow} ${styles.flexContainer}`} key={index}>
            <span className={styles.name}>{index + 1}. {player.name}</span>
            <span className={styles.points}>
              <div>{player.points}</div>
            </span>
          </div>
        ))}

        {sortedPlayers.length > visibleCount && (
          <a
            className={styles.showMoreBtn}
            onClick={() => {
              const newState = !showAll;
              setShowAll(newState);
              trackEvent("UI Interaction", `Toggle ${newState ? "Show More" : "Show Less"}`);
            }}
          >
            {showAll ? "Show Less" : "Show More"}
          </a>
        )}
      </div>
    </div>
  );
};

export default Leaderboard;
